import axios from "../axiosInstance";

class ProductGroupService {
  async getProductGroupList() {
    return await axios.get("productGroup");
  }
}

export default new ProductGroupService();
